(function () {
  "use strict";

  if (window.MTShopifyStorefrontCartEnhancerV178) return;
  window.MTShopifyStorefrontCartEnhancerV178 = true;

  var config = window.MTShopifyStorefrontCartEnhancerConfig || {};
  var endpoint = config.endpoint || "https://nqdkcs-mx.myshopify.com/api/2026-04/graphql.json";
  var token = config.token || "d7ef14b66d218d3f59a6b754bc1fcc99";
  var cookieName = config.cookieName || "mt_shopify_storefront_cart_id";
  var cartPageUrl = config.cartPageUrl || "https://moderntreasures.nl/winkelmand";
  var shopUrl = config.shopUrl || "https://shop.moderntreasures.nl";
  var currentCart = null;
  var isRefreshing = false;

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function money(amount, currencyCode) {
    try {
      return new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: currencyCode || "EUR"
      }).format(Number(amount || 0));
    } catch (e) {
      return "€" + Number(amount || 0).toFixed(2).replace(".", ",");
    }
  }

  function splitProductTitle(title) {
    var raw = String(title || "").trim();
    var match = raw.match(/^(.*?)(\s*\([^)]*\))\s*$/);
    if (!match) return { title: raw, subtitle: "" };
    return { title: match[1].trim(), subtitle: match[2].trim() };
  }

  function normalizeOptionName(value) {
    return String(value || "").toLowerCase().trim();
  }

  function normalizeOptionValue(value) {
    return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function optionNameMatches(name, names) {
    var normalized = normalizeOptionName(name);
    return names.some(function (target) {
      var targetName = normalizeOptionName(target);
      return normalized === targetName || normalized.indexOf(targetName) !== -1;
    });
  }

  function optionValue(options, names) {
    var found = (options || []).find(function (option) {
      return optionNameMatches(option.name, names);
    });
    return found ? found.value : "";
  }

  function setCartId(cartId) {
    if (!cartId) return;
    try {
      document.cookie = cookieName + "=" + encodeURIComponent(cartId) + "; domain=.moderntreasures.nl; path=/; max-age=2592000; SameSite=Lax; Secure";
    } catch (e) {}
    try {
      localStorage.setItem(cookieName, cartId);
    } catch (e) {}
  }

  function getCartId() {
    var match = document.cookie.match(new RegExp("(?:^|; )" + cookieName + "=([^;]*)"));
    if (match) return decodeURIComponent(match[1]);
    try { return localStorage.getItem(cookieName); } catch (e) { return null; }
  }

  function clearCartId() {
    try {
      document.cookie = cookieName + "=; domain=.moderntreasures.nl; path=/; max-age=0; SameSite=Lax; Secure";
    } catch (e) {}
    try { localStorage.removeItem(cookieName); } catch (e) {}
  }

  function gql(query, variables) {
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (response) {
      if (!response.ok) throw new Error("Storefront request failed: " + response.status);
      return response.json();
    }).then(function (json) {
      if (json.errors && json.errors.length) {
        throw new Error(json.errors[0].message || "Storefront API error");
      }
      return json.data;
    });
  }

  function cartFragment() {
    return `
      fragment MtShopifyCartFields on Cart {
        id
        checkoutUrl
        totalQuantity
        discountCodes { code applicable }
        cost {
          subtotalAmount { amount currencyCode }
          totalAmount { amount currencyCode }
        }
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              cost { totalAmount { amount currencyCode } }
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  availableForSale
                  image { url altText }
                  selectedOptions { name value }
                  product {
                    title
                    vendor
                    handle
                    onlineStoreUrl
                    variants(first: 100) {
                      edges {
                        node {
                          id
                          title
                          availableForSale
                          selectedOptions { name value }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  }

  function fetchCart(cartId) {
    var query = `
      ${cartFragment()}
      query MtShopifyCart($id: ID!) {
        cart(id: $id) { ...MtShopifyCartFields }
      }
    `;
    return gql(query, { id: cartId }).then(function (data) {
      if (!data.cart) {
        clearCartId();
        currentCart = null;
        return null;
      }
      currentCart = data.cart;
      setCartId(data.cart.id);
      return data.cart;
    });
  }

  function addLine(variantId, quantity) {
    var cartId = currentCart && currentCart.id ? currentCart.id : getCartId();
    if (!cartId) return Promise.reject(new Error("Geen Storefront cart gevonden."));

    var mutation = `
      ${cartFragment()}
      mutation MtShopifyCartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart { ...MtShopifyCartFields }
          userErrors { field message }
        }
      }
    `;
    return gql(mutation, {
      cartId: cartId,
      lines: [{ merchandiseId: variantId, quantity: Number(quantity || 1) }]
    }).then(function (data) {
      if (data.cartLinesAdd.userErrors && data.cartLinesAdd.userErrors.length) {
        throw new Error(data.cartLinesAdd.userErrors[0].message);
      }
      currentCart = data.cartLinesAdd.cart;
      setCartId(currentCart.id);
      return currentCart;
    });
  }

  function updateLine(lineId, quantity) {
    if (!currentCart || !currentCart.id) return Promise.reject(new Error("Geen actieve cart."));
    var mutation = `
      ${cartFragment()}
      mutation MtShopifyCartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart { ...MtShopifyCartFields }
          userErrors { field message }
        }
      }
    `;
    return gql(mutation, {
      cartId: currentCart.id,
      lines: [{ id: lineId, quantity: Number(quantity) }]
    }).then(function (data) {
      if (data.cartLinesUpdate.userErrors && data.cartLinesUpdate.userErrors.length) {
        throw new Error(data.cartLinesUpdate.userErrors[0].message);
      }
      currentCart = data.cartLinesUpdate.cart;
      setCartId(currentCart.id);
      return currentCart;
    });
  }

  function removeLine(lineId) {
    if (!currentCart || !currentCart.id) return Promise.reject(new Error("Geen actieve cart."));
    var mutation = `
      ${cartFragment()}
      mutation MtShopifyCartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart { ...MtShopifyCartFields }
          userErrors { field message }
        }
      }
    `;
    return gql(mutation, {
      cartId: currentCart.id,
      lineIds: [lineId]
    }).then(function (data) {
      if (data.cartLinesRemove.userErrors && data.cartLinesRemove.userErrors.length) {
        throw new Error(data.cartLinesRemove.userErrors[0].message);
      }
      currentCart = data.cartLinesRemove.cart;
      setCartId(currentCart.id);
      return currentCart;
    });
  }

  function updateLineVariant(lineId, variantId, quantity) {
    /* Safe route: add new variant first; remove old line only after successful add. */
    return addLine(variantId, quantity).then(function () {
      return removeLine(lineId);
    });
  }

  function productVariantEdges(product) {
    return product && product.variants && product.variants.edges ? product.variants.edges : [];
  }

  function sizeOptionsForVariant(variant, product) {
    var selectedOptions = variant.selectedOptions || [];
    var colorNames = ["Color", "Kleur", "Colour", "Kleuren", "Productkleur"];
    var sizeNames = ["Size", "Maat", "Grootte", "Taille", "Kledingmaat"];
    var currentColor = optionValue(selectedOptions, colorNames);
    var currentSize = optionValue(selectedOptions, sizeNames);
    var currentColorKey = normalizeOptionValue(currentColor);
    var currentSizeKey = normalizeOptionValue(currentSize);
    var variants = productVariantEdges(product);

    var sizeVariants = variants.filter(function (edge) {
      var node = edge.node || {};
      var opts = node.selectedOptions || [];
      var color = optionValue(opts, colorNames);
      if (!currentColorKey) return true;
      if (!color) return true;
      return normalizeOptionValue(color) === currentColorKey;
    }).map(function (edge) {
      var node = edge.node || {};
      var opts = node.selectedOptions || [];
      var size = optionValue(opts, sizeNames) || node.title || currentSize || "Maat";
      return {
        id: node.id,
        title: size,
        availableForSale: node.availableForSale,
        selected: node.id === variant.id || normalizeOptionValue(size) === currentSizeKey
      };
    });

    if (!sizeVariants.length && currentSize) {
      sizeVariants.push({ id: variant.id, title: currentSize, availableForSale: true, selected: true });
    }

    var seen = {};
    return sizeVariants.filter(function (item) {
      var key = normalizeOptionValue(item.title);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function getLine(lineId) {
    var edges = currentCart && currentCart.lines && currentCart.lines.edges ? currentCart.lines.edges : [];
    var found = edges.find(function (edge) { return edge.node.id === lineId; });
    return found ? found.node : null;
  }

  function getDrawer() {
    return document.getElementById("mt-shopify-cart") ||
      document.querySelector("cart-drawer") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".drawer");
  }

  function getDrawerPanel(drawer) {
    if (!drawer) return null;
    return drawer.querySelector(".mt-shopify-cart__panel") ||
      drawer.querySelector("#CartDrawer") ||
      drawer.querySelector(".drawer__inner") ||
      drawer;
  }

  function getModernDrawer() {
    return document.getElementById("mt-shopify-cart");
  }

  function markDrawerOpen() {
    document.documentElement.classList.add("mt-sfc-drawer-open");
    document.body.classList.add("mt-sfc-drawer-open");
  }

  function markDrawerClosed() {
    document.documentElement.classList.remove("mt-sfc-drawer-open");
    document.body.classList.remove("mt-sfc-drawer-open");
  }

  function openModernDrawer() {
    var drawer = getModernDrawer();
    if (!drawer) return false;

    drawer.classList.add("is-open", "active");
    drawer.setAttribute("aria-hidden", "false");
    markDrawerOpen();

    refreshDrawer();
    setTimeout(refreshDrawer, 160);
    return true;
  }

  function openThemeDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return false;

    try {
      if (typeof drawer.open === "function") drawer.open();
    } catch (e) {}

    drawer.classList.add("active", "animate", "mt-sfc-shopify-drawer-enhanced");
    var panel = getDrawerPanel(drawer);
    if (panel) panel.classList.add("mt-sfc-shopify-drawer-panel-enhanced");
    markDrawerOpen();

    refreshDrawer();
    setTimeout(refreshDrawer, 160);
    setTimeout(ensureViewCartButton, 220);
    return true;
  }

  function openEnhancedDrawer() {
    return openModernDrawer() || openThemeDrawer();
  }

  function closeModernDrawer() {
    var drawer = getModernDrawer();
    if (drawer) {
      drawer.classList.remove("is-open", "active");
      drawer.setAttribute("aria-hidden", "true");
    }

    var themeDrawer = document.querySelector("cart-drawer");
    if (themeDrawer && typeof themeDrawer.close === "function") {
      try { themeDrawer.close(); } catch (e) {}
    }
    if (themeDrawer) themeDrawer.classList.remove("active", "animate");
    markDrawerClosed();
  }

  function getItemsEl() {
    return document.getElementById("mt-shopify-cart-items") ||
      document.getElementById("MtStorefrontCartItems") ||
      document.querySelector("[data-mt-shopify-cart-items]") ||
      document.querySelector("cart-drawer-items") ||
      document.querySelector("#CartDrawer-CartItems") ||
      document.querySelector(".drawer__contents") ||
      document.querySelector(".cart-drawer__items");
  }

  function getTotalEl() {
    return document.getElementById("mt-shopify-cart-total") ||
      document.getElementById("MtStorefrontCartTotal") ||
      document.querySelector("[data-mt-shopify-cart-total]") ||
      document.querySelector("#CartDrawer-Total") ||
      document.querySelector(".totals__total-value") ||
      document.querySelector(".cart-drawer .totals .money");
  }

  function queryFirst(root, selectors) {
    if (!root) return null;
    for (var i = 0; i < selectors.length; i += 1) {
      var found = root.querySelector(selectors[i]);
      if (found) return found;
    }
    return null;
  }

  function getCheckoutBtn() {
    var selectors = [
      "#mt-shopify-cart-checkout",
      "#MtStorefrontCartCheckout",
      "[data-mt-shopify-cart-checkout]",
      "[data-mt-sfc-checkout]",
      "#CartDrawer-Checkout",
      "button[name='checkout']",
      ".cart__checkout-button"
    ];
    var panel = getDrawerPanel(getDrawer());
    return queryFirst(panel, selectors) || queryFirst(document, selectors);
  }

  function getBadgeEls() {
    return Array.prototype.slice.call(document.querySelectorAll("#mt-cart-badge, #mtx-mobile-cart-badge, .mt-cart-badge, .cart-count-bubble span[aria-hidden='true'], .cart-count-bubble"));
  }

  function updateBadges(cart) {
    var qty = cart && cart.totalQuantity ? cart.totalQuantity : 0;
    getBadgeEls().forEach(function (badge) {
      if (!badge) return;
      if (qty > 0) {
        badge.textContent = qty > 99 ? "99+" : qty;
        badge.classList.add("is-visible");
      } else {
        badge.textContent = "";
        badge.classList.remove("is-visible");
      }
    });
  }

  function buttonText(el) {
    return String(el && el.textContent ? el.textContent : "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function isViewCartButton(el) {
    var text = buttonText(el);
    return text.indexOf("winkelmand bekijken") !== -1 ||
      text.indexOf("naar winkelmand") !== -1 ||
      text.indexOf("winkelwagen bekijken") !== -1 ||
      text.indexOf("view cart") !== -1;
  }

  function viewCartButtons(panel) {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll("a, button")).filter(function (el) {
      return isViewCartButton(el);
    });
  }

  function findButtonRow(checkoutBtn) {
    if (!checkoutBtn) return null;
    return checkoutBtn.closest(".mt-drawer__ctas, .cart__ctas, .cart-drawer__ctas, .drawer__footer, .cart-drawer__footer") || checkoutBtn.parentNode;
  }

  function normaliseNativeDrawerControls() {
    Array.prototype.slice.call(document.querySelectorAll(".mt-drawer__size-select option")).forEach(function (option) {
      option.textContent = String(option.textContent || "").replace(/^\s*Maat\s+/i, "").replace(/\s+/g, " ").trim();
    });
  }

  function syncModernDrawerPresence() {
    var hasModernDrawer = !!getModernDrawer();
    document.documentElement.classList.toggle("mt-sfc-modern-drawer-present", hasModernDrawer);
    document.body.classList.toggle("mt-sfc-modern-drawer-present", hasModernDrawer);
  }

  function ensureViewCartButton() {
    syncModernDrawerPresence();

    var drawer = getDrawer();
    var panel = getDrawerPanel(drawer) || drawer;
    if (!panel) return;

    var footer = panel.querySelector(".mt-shopify-cart__footer, .drawer__footer, .cart-drawer__footer, .cart__footer, form");
    if (!footer) {
      footer = document.createElement("div");
      footer.className = "mt-sfc-drawer-footer-fallback";
      panel.appendChild(footer);
    }

    var actions = footer.querySelector(".mt-sfc-drawer-cta-row[data-mt-sfc-actions='true']");
    if (!actions) {
      actions = document.createElement("div");
      actions.className = "mt-sfc-drawer-cta-row";
      actions.setAttribute("data-mt-sfc-actions", "true");
      footer.appendChild(actions);
    }

    var viewButton = actions.querySelector("[data-mt-sfc-view-cart]");
    if (!viewButton) {
      viewButton = document.createElement("a");
      actions.appendChild(viewButton);
    }
    viewButton.id = "MtShopifyStorefrontViewCart";
    viewButton.textContent = "winkelwagen bekijken";
    viewButton.className = "mt-sfc-drawer-view-cart-btn mt-drawer__btn-secondary";
    viewButton.setAttribute("data-mt-sfc-view-cart", "true");
    viewButton.setAttribute("href", cartPageUrl);
    viewButton.setAttribute("role", "button");

    var checkoutUrl = (currentCart && currentCart.checkoutUrl) || (shopUrl.replace(/\/$/, "") + "/checkout");
    var directButton = actions.querySelector("[data-mt-sfc-checkout]");
    if (!directButton) {
      directButton = document.createElement("a");
      actions.appendChild(directButton);
    }
    directButton.id = "MtShopifyStorefrontCheckout";
    directButton.textContent = "direct bestellen";
    directButton.className = "mt-sfc-drawer-checkout-btn mt-drawer__btn-primary";
    directButton.setAttribute("data-mt-sfc-checkout", "true");
    directButton.setAttribute("href", checkoutUrl);
    directButton.setAttribute("role", "button");
    directButton.setAttribute("data-mt-sfc-checkout-url", checkoutUrl);

    if (actions.firstElementChild !== viewButton) actions.insertBefore(viewButton, actions.firstElementChild);
    if (viewButton.nextElementSibling !== directButton) actions.insertBefore(directButton, viewButton.nextSibling);

    Array.prototype.slice.call(panel.querySelectorAll("#CartDrawer-Checkout, button[name='checkout'], .cart__checkout-button, [data-mt-shopify-cart-checkout]")).forEach(function (btn) {
      if (btn.closest(".mt-sfc-drawer-cta-row[data-mt-sfc-actions='true']")) return;
      btn.setAttribute("data-mt-sfc-native-checkout-hidden", "true");
      btn.style.display = "none";
    });

    viewCartButtons(panel).forEach(function (btn) {
      if (btn === viewButton || btn.closest(".mt-sfc-drawer-cta-row[data-mt-sfc-actions='true']")) return;
      btn.setAttribute("data-mt-sfc-native-view-cart-hidden", "true");
      btn.style.display = "none";
    });

    actions.classList.add("mt-sfc-drawer-cta-row");
    normaliseNativeDrawerControls();
  }

  function renderDrawer(cart) {
    var drawer = getDrawer();
    var itemsEl = getItemsEl();
    var totalEl = getTotalEl();
    var checkoutBtn = getCheckoutBtn();
    var panel = getDrawerPanel(drawer);

    if (drawer) drawer.classList.add("mt-sfc-shopify-drawer-enhanced");
    if (panel) panel.classList.add("mt-sfc-shopify-drawer-panel-enhanced");
    ensureViewCartButton();

    currentCart = cart;
    updateBadges(cart);

    if (checkoutBtn && cart && cart.checkoutUrl) {
      checkoutBtn.setAttribute("data-mt-sfc-checkout-url", cart.checkoutUrl);
    }

    if (totalEl) {
      var totalAmount = cart && cart.cost && cart.cost.totalAmount ? cart.cost.totalAmount : null;
      totalEl.textContent = totalAmount ? money(totalAmount.amount, totalAmount.currencyCode) : money(0, "EUR");
    }

    if (!itemsEl) return;

    var edges = cart && cart.lines && cart.lines.edges ? cart.lines.edges : [];
    if (!edges.length) {
      itemsEl.innerHTML = '<div class="mt-sfc-drawer-empty">je winkelwagen is leeg.</div>';
      return;
    }

    itemsEl.innerHTML = edges.map(function (edge) {
      var line = edge.node;
      var variant = line.merchandise || {};
      var product = variant.product || {};
      var image = variant.image || {};
      var titleParts = splitProductTitle(product.title || "");
      var productUrl = product.handle ? shopUrl + "/products/" + product.handle : (product.onlineStoreUrl || shopUrl);
      var color = optionValue(variant.selectedOptions || [], ["Color", "Kleur", "Colour"]);
      var sizes = sizeOptionsForVariant(variant, product);
      var lineTotal = line.cost && line.cost.totalAmount ? line.cost.totalAmount : null;
      var vendor = product.vendor || "Modern Treasures";
      var subtitle = titleParts.subtitle;

      var sizeSelectHtml = "";
      if (sizes.length) {
        sizeSelectHtml = '<select class="mt-sfc-drawer-size-select" data-mt-sfc-drawer-size-select="' + escapeHtml(line.id) + '" aria-label="Maat kiezen">';
        sizeSelectHtml += sizes.map(function (item) {
          return '<option value="' + escapeHtml(item.id) + '"' + (item.selected ? " selected" : "") + (item.availableForSale ? "" : " disabled") + '>' + escapeHtml(item.title) + '</option>';
        }).join("");
        sizeSelectHtml += '</select>';
      }

      return `
        <div class="mt-sfc-drawer-line" data-line-id="${escapeHtml(line.id)}">
          <a class="mt-sfc-drawer-img" href="${escapeHtml(productUrl)}">
            <img src="${escapeHtml(image.url || "")}" alt="${escapeHtml(image.altText || product.title || "")}" loading="lazy">
          </a>
          <div class="mt-sfc-drawer-info">
            <span class="mt-sfc-drawer-vendor">${escapeHtml(vendor)}</span>
            <a class="mt-sfc-drawer-title" href="${escapeHtml(productUrl)}">${escapeHtml(titleParts.title || product.title || "")}</a>
            ${subtitle ? `<span class="mt-sfc-drawer-subtitle">${escapeHtml(subtitle)}</span>` : ""}
            ${color ? `<div class="mt-sfc-drawer-color">Color: <span>${escapeHtml(color)}</span></div>` : ""}
            ${sizeSelectHtml}
            <div class="mt-sfc-drawer-line-bottom">
              <div class="mt-sfc-drawer-qty">
                <button type="button" data-mt-sfc-drawer-minus="${escapeHtml(line.id)}" aria-label="Aantal verlagen">−</button>
                <span>${line.quantity}</span>
                <button type="button" data-mt-sfc-drawer-plus="${escapeHtml(line.id)}" aria-label="Aantal verhogen">+</button>
              </div>
              <button type="button" class="mt-sfc-drawer-remove" data-mt-sfc-drawer-remove="${escapeHtml(line.id)}" aria-label="Verwijderen">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
              </button>
              <div class="mt-sfc-drawer-price">${lineTotal ? money(lineTotal.amount, lineTotal.currencyCode) : ""}</div>
            </div>
          </div>
        </div>
      `;
    }).join("");
    normaliseNativeDrawerControls();
    ensureViewCartButton();
  }

  function emptyCartState() {
    return {
      id: null,
      checkoutUrl: "",
      totalQuantity: 0,
      cost: { totalAmount: { amount: 0, currencyCode: "EUR" } },
      lines: { edges: [] }
    };
  }

  function refreshDrawer() {
    var cartId = getCartId();
    if (!cartId) {
      renderDrawer(emptyCartState());
      return Promise.resolve(null);
    }
    if (isRefreshing) return Promise.resolve(currentCart);
    isRefreshing = true;
    return fetchCart(cartId).then(function (cart) {
      renderDrawer(cart || emptyCartState());
      return cart;
    }).catch(function (error) {
      console.error("Shopify drawer refresh mislukt:", error);
    }).then(function (cart) {
      isRefreshing = false;
      return cart;
    });
  }

  function dispatchUpdated(cart) {
    try {
      document.dispatchEvent(new CustomEvent("mt-storefront-cart:updated", { detail: cart }));
    } catch (e) {}
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      var modernClose = event.target.closest("#mt-shopify-cart-close, #mt-shopify-cart-overlay, .mt-shopify-cart__close, .mt-shopify-cart__overlay");
      if (modernClose && getModernDrawer()) {
        event.preventDefault();
        closeModernDrawer();
        return;
      }

      var viewBtn = event.target.closest("[data-mt-sfc-view-cart], #MtShopifyStorefrontViewCart, #MtSfcDrawerViewCart, #MtStorefrontCartView");
      if (viewBtn) {
        event.preventDefault();
        window.location.href = cartPageUrl;
        return;
      }

      var checkoutBtn = event.target.closest("#mt-shopify-cart-checkout, #MtStorefrontCartCheckout, #CartDrawer-Checkout, [data-mt-shopify-cart-checkout], [data-mt-sfc-checkout]");
      if (checkoutBtn) {
        var checkoutUrl = checkoutBtn.getAttribute("data-mt-sfc-checkout-url") || (currentCart && currentCart.checkoutUrl);
        if (checkoutUrl) {
          event.preventDefault();
          window.location.href = checkoutUrl;
          return;
        }
      }

      var minus = event.target.closest("[data-mt-sfc-drawer-minus]");
      var plus = event.target.closest("[data-mt-sfc-drawer-plus]");
      var remove = event.target.closest("[data-mt-sfc-drawer-remove]");

      if (minus) {
        event.preventDefault();
        var minusLineId = minus.getAttribute("data-mt-sfc-drawer-minus");
        var minusLine = getLine(minusLineId);
        if (!minusLine) return;
        var newMinusQty = Math.max(0, Number(minusLine.quantity || 0) - 1);
        (newMinusQty === 0 ? removeLine(minusLineId) : updateLine(minusLineId, newMinusQty)).then(function (cart) {
          renderDrawer(cart);
          dispatchUpdated(cart);
        });
        return;
      }

      if (plus) {
        event.preventDefault();
        var plusLineId = plus.getAttribute("data-mt-sfc-drawer-plus");
        var plusLine = getLine(plusLineId);
        if (!plusLine) return;
        updateLine(plusLineId, Number(plusLine.quantity || 0) + 1).then(function (cart) {
          renderDrawer(cart);
          dispatchUpdated(cart);
        });
        return;
      }

      if (remove) {
        event.preventDefault();
        removeLine(remove.getAttribute("data-mt-sfc-drawer-remove")).then(function (cart) {
          renderDrawer(cart);
          dispatchUpdated(cart);
        });
        return;
      }

      if (event.target.closest("#cart-icon-bubble, [data-mt-open-cart], [data-mt-cart-open], .header__icon--cart, .mt-gh-cart, .mt-nav__icon--cart, a[href='/cart'], a[href='/cart/'], a[href$='/cart'], button[aria-label*='cart' i], a[aria-label*='cart' i], button[aria-label*='winkelwagen' i], a[aria-label*='winkelwagen' i]")) {
        /* v1.7.8: do not block or replace Shopify's own cart-click flow.
           The cart click must keep working exactly as it already did in the theme.
           We only refresh/style after the drawer has opened naturally. */
        setTimeout(refreshDrawer, 120);
        setTimeout(scheduleSafeDrawerCleanup, 220);
        setTimeout(refreshDrawer, 520);
        setTimeout(scheduleSafeDrawerCleanup, 620);
      }
    }, true);

    document.addEventListener("change", function (event) {
      var select = event.target.closest("[data-mt-sfc-drawer-size-select]");
      if (!select) return;

      var lineId = select.getAttribute("data-mt-sfc-drawer-size-select");
      var line = getLine(lineId);
      var newVariantId = select.value;
      if (!line || !newVariantId || !line.merchandise || line.merchandise.id === newVariantId) return;

      select.disabled = true;
      updateLineVariant(lineId, newVariantId, line.quantity).then(function (cart) {
        renderDrawer(cart);
        dispatchUpdated(cart);
      }).catch(function (error) {
        console.error("Maat wijzigen in Shopify drawer mislukt:", error);
        refreshDrawer();
      });
    });

    document.addEventListener("mt-storefront-cart:updated", function (event) {
      if (event.detail) renderDrawer(event.detail);
      else refreshDrawer();
    });

    // v1.7.8: no MutationObserver and no cart-click override. Only styling/cleanup after natural drawer open.
  }

  function scheduleSafeDrawerCleanup() {
    setTimeout(function () {
      syncModernDrawerPresence();
      var drawer = getDrawer();
      var panel = getDrawerPanel(drawer);
      if (drawer) drawer.classList.add("mt-sfc-shopify-drawer-enhanced");
      if (panel) panel.classList.add("mt-sfc-shopify-drawer-panel-enhanced");
      ensureViewCartButton();
      normaliseNativeDrawerControls();
    }, 120);
  }

  function init() {
    bindEvents();
    scheduleSafeDrawerCleanup();
    refreshDrawer();

    window.mtShopifyStorefrontDrawerEnhancerRefresh = refreshDrawer;
  }

  onReady(init);
})();
